import { createSlice } from "@reduxjs/toolkit";
import { ISliceStatistic } from "@/shared/interfaces/Statistic";

const initialState: ISliceStatistic = {
    debtorsArray: [],
};

const statisticSlice = createSlice({
    name: "statistic",
    initialState,
    reducers: {
        setDebtorsArray: (state, action) => {
            state.debtorsArray = action.payload;
        },
    },
});

export const { setDebtorsArray } = statisticSlice.actions;
export default statisticSlice.reducer;
